<template>
  <div>
    <transition name="fade">
      <component :is="layout">
        <router-view/>
      </component>
    </transition>
  </div>
</template>

<script>
  export default {
    computed: {
      layout() {
        let layout = this.$route.meta.layout
        if (!layout) {
          layout = this.$store.state.auth.authenticated ? 'default' : 'anonymous'
        }

        return layout + '-layout'
      }
    },
  }
</script>

<style>
  #test-messages {
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: left;
    list-style-type: none;
  }
  #test-messages button {
    padding: 5px 10px;
    background: #CCC;
    margin-bottom: 10px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .6s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
     animation-name: leave;
     animation-duration: 0.8s;
  }

  @keyframes leave {
    from {opacity: 1;}
    to {opacity: 0;}
  }
</style>
